/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KubernetesClusterFrequency {
    getFixupPrototypeFunction() { return KubernetesClusterFrequency.fixupPrototype; }

    static newInstance(model: Partial<KubernetesClusterFrequency>): KubernetesClusterFrequency {
        let obj = Object.assign(new KubernetesClusterFrequency(), model);
        KubernetesClusterFrequency.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KubernetesClusterFrequency>): KubernetesClusterFrequency {
        if (!model) return null;
        return KubernetesClusterFrequency.newInstance(<KubernetesClusterFrequency> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KubernetesClusterFrequency) {
        if (!obj) return;

        models.KubernetesClusterFrequency.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KubernetesClusterFrequency): boolean {
        Object.setPrototypeOf(obj, KubernetesClusterFrequency.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cost_resolution) {
            models.ClusterFrequencyTimeDetails.fixupPrototype(this.cost_resolution);
        }
    }

    /**
     * Cost Resolution Details
     */
    cost_resolution: models.ClusterFrequencyTimeDetails;

}
